module.exports = __webpack_public_path__ + "static/assets/c2073917e0491bdcb2d046d298bcd083.png";